"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TableSortLabel2 = _interopRequireDefault(require("@material-ui/core/TableSortLabel"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _TableSortLabel3 = _interopRequireDefault(require("./TableSortLabel.styles"));

// eslint-disable-next-line react/prop-types
function Icon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    style: {
      width: 16,
      height: 16
    },
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "round"
  }));
}

function TableSortLabel(props) {
  var classes = (0, _TableSortLabel3.default)();
  return /*#__PURE__*/_react.default.createElement(_TableSortLabel2.default, Object.assign({}, props, {
    classes: classes,
    IconComponent: Icon
  }));
}

TableSortLabel.propTypes = {
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   */
  active: _propTypes.bool,

  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: _propTypes.node,

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * The current sort direction.
   */
  direction: (0, _propTypes.oneOf)(['asc', 'desc'])
};
var _default = TableSortLabel;
exports.default = _default;
